const SLOW_THRESHOLD_MS = 3000;

export async function withLatencyWarning<T>(label: string, fn: () => Promise<T>): Promise<T> {
    const start = performance.now();
    const result = await fn();
    const ms = performance.now() - start;
    if (ms > SLOW_THRESHOLD_MS) {
        console.warn(`[performance] ${label} took ${Math.round(ms)}ms`);
    }
    return result;
}
